import React, { Fragment, useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import DataTable from "../../../../Common/Components/DataTable";
import Loading from "../../../../Common/Components/Loading";
import { useAthelets } from "../Hooks";
import { RtlMui } from "../../../../../App/component/rtlMui";
import TableSearch from "../../../../Common/Components/DataTable/TableSearch";
import ItemAthlet from "../../../../../App/Panel/Athletes/subsets/ItemAthlet";
import { BsFilter } from "react-icons/bs";
const DeactiveList = ({ isApp, isGYM }) => {
  const { data, getAthelets, loading, searchHandler } = useAthelets();
  const [reverseData, SetReverseData] = useState(false)

  const finalData = (data) => {
    if (reverseData) {
      return data.slice(0).reverse()
    }
    return data
  }
  useEffect(() => {
    getAthelets();
  }, []);
  // search

  return (
    <Fragment>
      <Helmet>
        <title>نیکوتن | لیست کامل ورزشکاران</title>
      </Helmet>

      <Fragment>

        {isApp && <>

           {/* نمایش فیلتر صعودی  و  نزولی برای  اپ */}
           <div className="my-4" style={{ color: reverseData ? "red" : "blue" }} onClick={() => SetReverseData(!reverseData)}>
            <BsFilter className={"ml-2"} size={24} />
            {reverseData ? "قدیمی‌ترین" : "جدیدترین"}
          </div>
          <RtlMui>
            <TableSearch className={"mb-2"} label={"جستجوی کاربر بر اساس نام، شماره تماس یا کد ملی"} search={searchHandler} />
          </RtlMui>

          {loading.list
            ? <Loading col="12" height="50px" count="3" />
            : data?.data?.length > 0
              ? finalData(data.data).map((item, index) => (
                <ItemAthlet isGYM={isGYM} data={item} key={index} />
              ))
              : <p className="text-center mt-3 bg-transparent">  سفارشی یافت نشد !   </p>
          }
        </>}


        {!isApp && <DataTable
          loading={loading.list}
          heads={[
            {
              title: "نام نام خانوادگی",
              key: "fullname",
            },
            {
              title: "کد ملی",
              key: "national_code",
            },
            {
              title: "شماره همراه",
              key: "mobile",
            },
            {
              title: "تاریخ آخرین خرید",
              key: "date_reserve",
              type: "date",
              timetype: "date-time",
            },
            {
              title: "تعداد روز های غیر فعالی",
              key: "countday_last_reserve",
            },
          ]}
          search={searchHandler}
          textEmpty=" "
          list={data.data}
          data={data}
          function={getAthelets}
          currentPage={data.current_page}
          links={[]}
        />
        }
      </Fragment>
    </Fragment>
  );
};

export default DeactiveList;
